import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import Header from '../components/Header.tsx';
import Footer from '../components/Footer.tsx';
import { useAuthAPI } from '../hooks/useAuth.ts';
import { useAuth } from '../contexts/AuthContext.tsx';                
import { getUserToken } from '../utils/helpers';
import { GoogleOAuthProvider } from '@react-oauth/google';
import GoogleLoginButton from '../components/GoogleLoginButton.js';


const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [localError, setLocalError] = useState<string | null>(null);
  const { loading, error, data, signIn } = useAuthAPI();
  const navigate = useNavigate();
  const location = useLocation();
  const userToken = getUserToken();
  const [loginSuccess, setLoginSuccess] = useState(false);
  const { login: globalLogin } = useAuth(); // Context API
  const handleMouseEnter = () => {
    console.log("Usuário está prestes a clicar em 'Sign In'");
  };
  // Extrair path de redirecionamento
  const getRedirectPath = () => {
    const state = location.state as any;

    // console.log("📍 Login - location.state:", state);

    if (state?.from) {
      // Se from é um objeto (vindo do ProtectedRoute)
      if (typeof state.from === 'object' && state.from.pathname) {
        return state.from.pathname;
      }
      // Se from é uma string direta
      if (typeof state.from === 'string') {
        return state.from;
      }
    }

    // Fallback para dashboard
    return '/dashboard';
  };

  const from = getRedirectPath();
  // console.log("📍 Login - Redirecionando para:", from);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLocalError(null);

    try {
      const res = await signIn(email, password);
      if (!res) return;
      console.log("🔍 Resultado do signIn:", res);

      if (res && res.verified === false) {
        console.log("Conta não verificada, redirecionando...");
        navigate(`/verify/${btoa(email)}`, {
          state: { from: location.state?.from || { pathname: '/dashboard' } }
        });
        return;
      }

      if (!res || !res.access_token) {
        const errorMessage =
          error?.message || 'Invalid credentials. Please check your email and password.';
        setLocalError(errorMessage);
        return;
      }

      const token = res.access_token;
      // Salvar email se necessário
      localStorage.setItem('userEmail', email);
      setLoginSuccess(true);

      // 🔥 CHAVE: Usar o globalLogin do Context API
      console.log("🔄 Login - Chamando globalLogin...");
      globalLogin(token, email);

      console.log("📍 Login - Navegando para:", from);

      // Pequeno delay para garantir atualização
      setTimeout(() => {
        navigate(from, { replace: true });
      }, 100);
      // Redirecionar
      console.log("Redirecionando para:", from);
      navigate(from, { replace: true });

    } catch (err: any) {
      console.error('Erro completo ao logar:', err);

      const errorData = err?.response?.data || error;
      const errorMessage = errorData?.message || err?.message || '';

      const isNotVerified =
        errorData?.verified === false ||
        errorMessage.toLowerCase().includes('verify') ||
        errorMessage.toLowerCase().includes('confirm') ||
        errorMessage.toLowerCase().includes('verification');

      if (isNotVerified) {
        console.log("Redirecionando para verificação...");
        navigate(`/verify/${btoa(email)}`, {
          state: { from: location.state?.from || { pathname: '/dashboard' } }
        });
        return;
      }

      setLocalError(
        errorMessage ||
        'Unable to log in. Please check your credentials.'
      );
    }
  };

  // Funções para login social
  const handleGoogleLogin = () => {
    // console.log('Google login clicked');
    // Implementar lógica de login com Google
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/google`;
  };

  const handleFacebookLogin = () => {
    // console.log('Facebook login clicked');
    // Implementar lógica de login com Facebook
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/facebook`;
  };

  const handleLinkedInLogin = () => {
    // console.log('LinkedIn login clicked');
    // Implementar lógica de login com LinkedIn
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/linkedin`;
  };

  // Adicione também um log para debug
  useEffect(() => {
    // console.log("Estado da localização:", location.state);
    // console.log("Redirecionando para:", from);
  }, [location.state, from]);
  useEffect(() => {
    if (error) {
      console.log("Erro capturado do useAuth:", error);

      if ('verified' in error && !error.verified) {
        console.log("Conta não verificada detectada pelo hook useAuth");
        navigate(`/verify/${btoa(email)}`);
        return;
      }

      if (error.message?.includes('401') || error.status === 401) {
        setLocalError('Incorrect email or password. Please check your credentials.');
      }
    }
  }, [error, navigate]);

  useEffect(() => {
    // console.log("📍 DEBUG - Login Location State:");
    // console.log("location.state:", location.state);
    // console.log("location.state type:", typeof location.state);

    if (location.state) {
      // console.log("location.state keys:", Object.keys(location.state));
      // console.log("location.state.from:", location.state.from);

      if (location.state.from) {
        // console.log("location.state.from type:", typeof location.state.from);

        if (typeof location.state.from === 'object') {
          // console.log("location.state.from keys:", Object.keys(location.state.from));
          // console.log("location.state.from.pathname:", location.state.from.pathname);
        }
      }
    }

    // console.log("Calculated 'from' path:", from);
  }, [location.state, from]);


  // console.log("Google client", process.env.REACT_APP_GOOGLE_CLIENT_ID)
  
  return (
    <>
      <Header />
      <section className="account padding-top padding-bottom sec-bg-color2">
        <div className="container">

          <div
            className="account__wrapper"
            data-aos="fade-up"
            data-aos-duration="800"
            style={{ display: 'contents' }}
          >
            <div className="account__inner">
              <div className="row align-items-center">
                {/* Coluna imagem */}
                <div className="col-lg-6">
                  <div className="account__thumb">
                    <img
                      src="/images/login/login1.png"
                      alt="Login illustration"
                      width={700}
                      height={200}
                      style={{
                        borderRadius: '20px',
                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                      }}
                    />
                  </div>
                </div>

                {/* Coluna formulário */}
                <div className="col-lg-6">
                  <div className="account__content account__content--style2">
                    {/* Header modernizado */}
                    <div className="account__header text-center mb-5">
                      <div className="mb-4">
                        <div style={{
                          width: '60px',
                          height: '60px',
                          background: '#00D094',
                          borderRadius: '15px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 15px',
                          boxShadow: '0 10px 20px #00D094'
                        }}>
                          <i className="fas fa-chart-line" style={{ color: 'white', fontSize: '24px' }}></i>
                        </div>
                        <h2 style={{
                          fontSize: '2.5rem',
                          // background: '#00D094',
                          color: '#fff',
                          WebkitBackgroundClip: 'text',
                          marginTop: '30px',
                          marginBottom: '0px'
                        }}>
                          Welcome Back
                        </h2>
                      </div>
                      <p style={{
                        color: '#6c757d',
                        fontSize: '1.1rem',
                        lineHeight: '1.6'
                      }}>
                        Track the best binary signals and maximize your profits with AI-powered insights.
                      </p>
                    </div>

                    {/* Botões de Login Social */}
                    {/* <div className="social-login mb-4">
                      <div className="row g-3">
                        <div className="col-4">
                          <button
                            type="button"
                            className="social-btn google-btn"
                            onClick={handleGoogleLogin}
                            style={{
                              width: '100%',
                              padding: '12px',
                              border: '2px solid #e0e0e0',
                              borderRadius: '12px',
                              background: 'white',
                              color: '#757575',
                              fontWeight: '600',
                              fontSize: '14px',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.borderColor = '#db4437';
                              e.currentTarget.style.transform = 'translateY(-2px)';
                              e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.borderColor = '#e0e0e0';
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = 'none';
                            }}
                          >
                            <i className="fab fa-google" style={{ color: '#db4437' }}></i>
                          </button>
                        </div>
                        <div className="col-4">
                          <button
                            type="button"
                            className="social-btn facebook-btn"
                            onClick={handleFacebookLogin}
                            style={{
                              width: '100%',
                              padding: '12px',
                              border: '2px solid #e0e0e0',
                              borderRadius: '12px',
                              background: 'white',
                              color: '#757575',
                              fontWeight: '600',
                              fontSize: '14px',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.borderColor = '#4267B2';
                              e.currentTarget.style.transform = 'translateY(-2px)';
                              e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.borderColor = '#e0e0e0';
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = 'none';
                            }}
                          >
                            <i className="fab fa-facebook-f" style={{ color: '#4267B2' }}></i>
                          </button>
                        </div>
                        <div className="col-4">
                          <button
                            type="button"
                            className="social-btn linkedin-btn"
                            onClick={handleLinkedInLogin}
                            style={{
                              width: '100%',
                              padding: '12px',
                              border: '2px solid #e0e0e0',
                              borderRadius: '12px',
                              background: 'white',
                              color: '#757575',
                              fontWeight: '600',
                              fontSize: '14px',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.borderColor = '#0077b5';
                              e.currentTarget.style.transform = 'translateY(-2px)';
                              e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.borderColor = '#e0e0e0';
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = 'none';
                            }}
                          >
                            <i className="fab fa-linkedin-in" style={{ color: '#0077b5' }}></i>
                          </button>
                        </div>
                      </div>
                    </div> */}

                    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}>
                      <GoogleLoginButton setLoginSuccess={setLoginSuccess} />
                    </GoogleOAuthProvider>

                    <div className="divider mb-4 mt-4">
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        textAlign: 'center',
                        color: '#6c757d',
                        fontSize: '14px'
                      }}>
                        <div style={{ flex: 1, height: '1px', background: '#e0e0e0' }}></div>
                        <span style={{ padding: '0 15px' }}>or continue with email</span>
                        <div style={{ flex: 1, height: '1px', background: '#e0e0e0' }}></div>
                      </div>
                    </div>

                    <form className="account__form needs-validation" onSubmit={handleSubmit}>
                      <div className="row g-4">
                        <div className="col-12">
                          <div className="form-group">
                            <label htmlFor="account-email" className="form-label" style={{
                              fontWeight: '600',
                              marginBottom: '8px',
                              color: '#fff'
                            }}>
                              Email Address
                            </label>
                            <div className="input-group-custom">
                              <input
                                type="email"
                                className="form-control modern-input"
                                id="account-email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email"
                                required
                                style={{
                                  width: '100%',
                                  padding: '15px 20px',
                                  border: '2px solid #e8f0fe',
                                  borderRadius: '12px',
                                  fontSize: '16px',
                                  transition: 'all 0.3s ease',
                                  background: '#f8f9fa',
                                  color: '#00D094'
                                }}
                                onFocus={(e) => {
                                  e.target.style.borderColor = '#00D094';
                                  e.target.style.background = 'white';
                                  e.target.style.boxShadow = '0 0 0 0.5px 0#0D094';
                                }}
                                onBlur={(e) => {
                                  e.target.style.borderColor = '#e8f0fe';
                                  e.target.style.background = '#f8f9fa';
                                  e.target.style.boxShadow = 'none';
                                }}
                              />
                              <i className="fas fa-envelope input-icon login-email-icon"></i>
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="form-group">
                            <label htmlFor="account-pass" className="form-label" style={{
                              fontWeight: '600',
                              marginBottom: '8px',
                              color: '#fff'
                            }}>
                              Password
                            </label>
                            <div className="form-pass" style={{ position: 'relative' }}>
                              <input
                                type={showPassword ? 'text' : 'password'}
                                className="form-control modern-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                id="account-pass"
                                placeholder="Enter your password"
                                required
                                style={{
                                  width: '100%',
                                  padding: '15px 50px 15px 20px',
                                  border: '2px solid #e8f0fe',
                                  borderRadius: '12px',
                                  fontSize: '16px',
                                  transition: 'all 0.3s ease',
                                  background: '#f8f9fa',
                                  color: '#00D094'
                                }}
                                onFocus={(e) => {
                                  e.target.style.borderColor = '#00D094';
                                  e.target.style.background = 'white';
                                  e.target.style.boxShadow = '0 0 0 0.5px #00D094';
                                }}
                                onBlur={(e) => {
                                  e.target.style.borderColor = '#e8f0fe';
                                  e.target.style.background = '#f8f9fa';
                                  e.target.style.boxShadow = 'none';
                                }}
                              />
                              <button
                                onClick={() => setShowPassword((prev) => !prev)}
                                type="button"
                                className="form-pass__toggle modern-toggle"
                                style={{
                                  position: 'absolute',
                                  right: '15px',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  background: 'none',
                                  border: 'none',
                                  color: '#00D094',
                                  cursor: 'pointer',
                                  padding: '5px',
                                  borderRadius: '5px',
                                  transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.background = '#00D094';
                                  e.currentTarget.style.color = '#fff';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.background = 'none';
                                  e.currentTarget.style.color = '#00D094';
                                }}
                              >
                                <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="account__check d-flex justify-content-between mt-4 align-items-center">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input modern-checkbox"
                            id="terms-check"
                            style={{
                              width: '18px',
                              height: '18px',
                              borderRadius: '4px',
                              border: '2px solid #dee2e6',
                              cursor: 'pointer'
                            }}
                          />
                          <label className="form-check-label" htmlFor="terms-check" style={{
                            color: '#fff',
                            cursor: 'pointer'
                          }}>
                            Remember me
                          </label>
                        </div>
                        <div>
                          <a href="/forgot-password" style={{
                            color: '#fff',
                            textDecoration: 'none',
                            fontWeight: '600',
                            transition: 'color 0.3s ease'
                          }}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#00D094'}
                            onMouseLeave={(e) => e.currentTarget.style.color = '#00D094'}
                          >
                            Forgot Password?
                          </a>
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="trk-btn trk-btn--border trk-btn--primary d-block mt-4 w-100"
                        disabled={loading}
                        onMouseEnter={handleMouseEnter}
                        style={{
                          background: 'linear-gradient(135deg, #00D094 0%, #00D094 100%)',
                          border: 'none',
                          padding: '15px',
                          borderRadius: '12px',
                          color: 'white',
                          fontWeight: '600',
                          fontSize: '16px',
                          cursor: loading ? 'not-allowed' : 'pointer',
                          transition: 'all 0.3s ease',
                          opacity: loading ? 0.7 : 1
                        }}
                        onMouseEnter={(e) => {
                          if (!loading) {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 10px 20px #00D094';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!loading) {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = 'none';
                          }
                        }}
                      >
                        {loading ? (
                          <>
                            <i className="fas fa-spinner fa-spin me-2"></i>
                            Signing In...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-sign-in-alt me-2"></i>
                            Sign In
                          </>
                        )}
                      </button>

                      {/* Exibição de erros formatados */}
                      {(localError || error) && (
                        <div style={{
                          background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)',
                          color: 'white',
                          padding: '12px 16px',
                          borderRadius: '8px',
                          marginTop: '15px',
                          textAlign: 'center',
                          fontWeight: '500'
                        }}>
                          <i className="fas fa-exclamation-triangle me-2"></i>
                          {localError || error?.message || "An error occurred while trying to log in."}
                        </div>
                      )}
                    </form>

                    <div className="account__switch text-center mt-4">
                      <p style={{ color: '#6c757d' }}>
                        Don't have an account?{' '}
                        <Link to="/register" style={{
                          color: '#fff',
                          textDecoration: 'none',
                          fontWeight: '600',
                          transition: 'color 0.3s ease'
                        }}
                          onMouseEnter={(e) => e.currentTarget.style.color = '#00D094'}
                          onMouseLeave={(e) => e.currentTarget.style.color = '#fff'}
                        >
                          Sign Up Now
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Login;